const middleware = {}

middleware['checkout'] = require('../_theme/middleware/checkout.js')
middleware['checkout'] = middleware['checkout'].default || middleware['checkout']

middleware['i18n'] = require('../_theme/middleware/i18n.js')
middleware['i18n'] = middleware['i18n'].default || middleware['i18n']

middleware['is-authenticated'] = require('../_theme/middleware/is-authenticated.js')
middleware['is-authenticated'] = middleware['is-authenticated'].default || middleware['is-authenticated']

middleware['is-authenticated'] = require('../_theme/middleware/is-authenticated.ts')
middleware['is-authenticated'] = middleware['is-authenticated'].default || middleware['is-authenticated']

middleware['router-init'] = require('../_theme/middleware/router-init.js')
middleware['router-init'] = middleware['router-init'].default || middleware['router-init']

export default middleware
